/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Button, FormGroup, Label, Col } from 'reactstrap'

import {AppContext} from '../../AppContext';

class ProcessAutomation extends React.Component
{
  componentDidMount()
  {
    this.getAutomationStatus();
  }

  constructor(props)
  {
    super();

    this.state =
    {
      automationEnabled: ''
    }

    this.toggleAutomation = this.toggleAutomation.bind(this);
    this.getAutomationStatus = this.getAutomationStatus.bind(this);
  }

  async getAutomationStatus()
  {
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getProcessAutomationStatus');
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error getting automation status');

    this.setState(
    {
      automationEnabled: result.jsonData.automationEnabled
    })
  }

  render()
  {    
    let toggleText = ('Y' === this.state.automationEnabled ? 'Push to Disable' : 'Push to Enable');
    let toggleSpan = ('Y' === this.state.automationEnabled ? 
      'Process automation is enabled. Press this button to disable automation.' : 
      'Process automation is disabled. Press this button to enable automation.');

    return(
      <div>
        <FormGroup row style={{paddingTop: "10px"}}>
          <Label for='enableAutomationButton' sm='2'>Process Automation Status:</Label>
          <Col sm='3'>
            <Button title={toggleSpan} color='primary' onClick={this.toggleAutomation}>{toggleText}</Button>
          </Col>
        </FormGroup>
      </div>
    );
  }  

  async toggleAutomation()
  {
    let entryPoint = 'Y' === this.state.automationEnabled ? 'disableProcessAutomation' : 'enableProcessAutomation';
    let result = await this.context.dbTwig.callRestAPI('dgBunker', entryPoint);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error toggling automation status');

    this.getAutomationStatus();
  }
}

ProcessAutomation.contextType = AppContext;

export default ProcessAutomation
